import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
const CommonTabs = ({ selectedValue, onChange, tabs, sx, fullWidth = false, disabled = false, }) => {
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: `
                @media (max-width: 600px) {
                    .common-tabs-btn { padding: 6px 10px !important; }
                }
            ` }), _jsx(Box, { sx: {
                    display: "flex",
                    backgroundColor: "#FAFAFA",
                    border: "1px solid #e5e7eb",
                    borderRadius: "8px",
                    padding: "4px",
                    width: fullWidth ? "100%" : { xs: "100%", sm: "fit-content" },
                    overflowX: { xs: "auto", sm: "unset" },
                    flexWrap: "nowrap",
                    "&::-webkit-scrollbar": { display: "none" },
                    scrollbarWidth: "none",
                    opacity: disabled ? 0.6 : 1,
                    pointerEvents: disabled ? "none" : "auto",
                    ...sx,
                }, children: tabs.map((tab) => {
                    const isActive = selectedValue === tab.value;
                    return (_jsx("button", { disabled: disabled, onClick: () => !disabled && onChange(tab.value), className: "all-Font-Sizes common-tabs-btn", style: {
                            padding: "8px 24px",
                            outline: "none",
                            background: isActive ? "#FFFAFD" : "transparent",
                            border: isActive
                                ? "1px solid #FFC8E9"
                                : "none",
                            color: isActive ? "#FF008E" : "#6b7280",
                            fontWeight: 500,
                            cursor: disabled ? "not-allowed" : "pointer",
                            borderRadius: "8px",
                            whiteSpace: "nowrap",
                            flex: fullWidth ? "1 1 0" : undefined,
                            textAlign: "center",
                            flexShrink: 0,
                            boxShadow: isActive
                                ? "0 1px 2px rgba(0,0,0,0.08)"
                                : "none",
                            // transition: "all 0.2s ease",
                        }, children: tab.label }, String(tab.value)));
                }) })] }));
};
export default CommonTabs;
